import Skeleton from "@/v2-ui/skeleton"
import cn from "@/v2-ui/utils/utils.cn"

export type FeatureConfigurationSkeletonProps = {
  className?: string
}

/**
 * The configuration tab's shape while the feature row lands. Matches the
 * editor's min-height so the tab does not grow when the document arrives —
 * and does not pre-empt the link-out this tab shows instead for basemaps
 * and map layers, which is why it is a plain block rather than a fake
 * editor chrome.
 */
function FeatureConfigurationSkeleton(
  props: FeatureConfigurationSkeletonProps,
) {
  const { className } = props

  return (
    <div
      className={cn("flex min-h-[420px] flex-col gap-2 p-3", className)}
      aria-busy="true"
    >
      <Skeleton className="h-full min-h-0 flex-1 rounded-md" />
    </div>
  )
}

export default FeatureConfigurationSkeleton
